/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Tag_SubtitleInputs */

const en_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize your focus time with precision.`)
};

const ar_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظم وقت تركيزك بدقة.`)
};

const de_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisieren Sie Ihre Konzentrationszeit mit Präzision.`)
};

const es_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organiza tu tiempo de concentración con precisión.`)
};

const fr_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planifiez vos moments de concentration avec précision.`)
};

const it_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizza con precisione il tuo tempo di concentrazione.`)
};

const ja_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中する時間を正確に整理`)
};

const ko_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 시간을 정확하게 관리하세요.`)
};

const pt_br_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize seu tempo de foco com precisão.`)
};

const ru_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организуйте свое время фокусировки с точностью до мелочей.`)
};

const th_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดระเบียบเวลาที่คุณต้องการโฟกัสได้อย่างแม่นยำ`)
};

const tr_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma zamanını titizlikle düzenle.`)
};

const zh_cn_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精准分类你的专注时间`)
};

const zh_tw_subscription_exclusive_feature_tag_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精準分類你的專注時間`)
};

/**
* | output |
* | --- |
* | "Organize your focus time with precision." |
*
* @param {Subscription_Exclusive_Feature_Tag_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_tag_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Tag_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Tag_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_tag_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_tag_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_tag_subtitle(inputs)
});